"use client";
import type { QuestionnaireField } from "@repo/questionnaire";

import {
  SensitiveSavedValueSchema,
  type QuestionnaireAnswers,
} from "@repo/questionnaire";

function isPlaceholder(value: unknown): boolean {
  if (SensitiveSavedValueSchema.safeParse(value).success) return true;
  return value === "[saved]";
}

/** Keep local typed answers authoritative; only adopt server redaction placeholders. */
export function mergeAuthoritativeAnswers(
  local: QuestionnaireAnswers,
  server: QuestionnaireAnswers | undefined,
): QuestionnaireAnswers {
  if (!server) return local;
  const merged: QuestionnaireAnswers = { ...server };
  for (const [binding, value] of Object.entries(local)) {
    if (!isPlaceholder(value)) {
      merged[binding] = value;
    }
  }
  return merged;
}

export function isPrivateContactField(field: QuestionnaireField): boolean {
  if (field.kind === "phone") return true;
  if (
    field.analyticsKey === "intake.full_name" ||
    field.analyticsKey === "intake.email" ||
    field.analyticsKey === "intake.phone"
  ) {
    return true;
  }
  return field.kind === "text" && Boolean(field.pattern?.includes("@"));
}
